// ============================================================
// Staff Documents API — Staff Document Management
// ============================================================

import client from './axios';

export const staffDocumentsApi = {
  // Get all documents for a staff member
  getAll: async (staffId, schoolId) => {
    const response = await client.get('/staff/documents/', {
      params: { staff_id: staffId, school_id: schoolId },
    });
    return response.data;
  },

  // Get a single staff document by ID
  getById: async (documentId, staffId, schoolId) => {
    const response = await client.get(`/staff/documents/${documentId}`, {
      params: { staff_id: staffId, school_id: schoolId },
    });
    return response.data;
  },

  // Upload/Create a new staff document
  create: async (staffId, schoolId, { document_type, document_name, file }) => {
    const formData = new FormData();
    formData.append('document_type', document_type || '');
    if (document_name) {
      formData.append('document_name', document_name);
    }
    if (file) {
      formData.append('file', file);
    }

    const response = await client.post('/staff/documents/', formData, {
      params: {
        staff_id: staffId,
        school_id: schoolId,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update an existing staff document
  update: async (documentId, staffId, schoolId, { document_type, document_name, file }) => {
    const formData = new FormData();
    if (document_type) formData.append('document_type', document_type);
    if (document_name) formData.append('document_name', document_name);
    if (file) formData.append('file', file);

    const response = await client.put(`/staff/documents/${documentId}`, formData, {
      params: {
        staff_id: staffId,
        school_id: schoolId,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete a staff document
  delete: async (documentId, staffId, schoolId) => {
    const response = await client.delete(`/staff/documents/${documentId}`, {
      params: {
        staff_id: staffId,
        school_id: schoolId,
      },
    });
    return response.data;
  },
};
